"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _Provider = _interopRequireDefault(require("../../providers/Config/Provider"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Layout = (0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../../containers/Layout/Layout'));
  });
});

var App = function App(_ref) {
  var appConfig = _ref.config;

  var config = _extends({}, appConfig);

  var pages = config.pages,
      components = config.components,
      containers = config.containers;

  var _ref2 = pages || {},
      _ref2$LandingPage = _ref2.LandingPage,
      LandingPage = _ref2$LandingPage === void 0 ? false : _ref2$LandingPage;

  var _ref3 = components || {},
      _ref3$Loading = _ref3.Loading,
      Loading = _ref3$Loading === void 0 ? function () {
    return /*#__PURE__*/_react["default"].createElement("div", null);
  } : _ref3$Loading;

  var _ref4 = containers || {},
      _ref4$AppContainer = _ref4.AppContainer,
      AppContainer = _ref4$AppContainer === void 0 ? _react["default"].Fragment : _ref4$AppContainer;

  return /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react["default"].createElement(Loading, null)
  }, /*#__PURE__*/_react["default"].createElement(_Provider["default"], {
    appConfig: config
  }, /*#__PURE__*/_react["default"].createElement(AppContainer, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.BrowserRouter, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Routes, null, LandingPage && /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: "/",
    exact: true,
    element: /*#__PURE__*/_react["default"].createElement(LandingPage, null)
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: "*",
    element: /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
      fallback: /*#__PURE__*/_react["default"].createElement(Loading, null)
    }, /*#__PURE__*/_react["default"].createElement(Layout, {
      appConfig: config
    }))
  }))))));
};

var _default = App;
exports["default"] = _default;
module.exports = exports.default;